import React from "react"
import PropTypes from "prop-types";
import Tr from "translations/Translations";
import GeneralInfoEntry from "../../panels/generalInfo/components/GeneralInfoEntry";
import OfferInput from "./inputs/OfferInput";


function OfferPositionCriteriums(
    {
        formikProps,
        criteriums,
        priceType,
        disabled
    }) {

    if (criteriums.length === 0)
        return null;

    return (
        <GeneralInfoEntry biggerLabel label={Tr('criteria_desc')} collapsible defaultCollapsed={false}>
            {
                criteriums.map((criterion, index) => (
                    <OfferInput
                        key={criterion.criterium.identity}
                        id={`criteriums.${index}`}
                        criterion={criterion}
                        formikProps={formikProps}
                        priceType={priceType}
                        disabled={disabled}
                    />
                ))}
        </GeneralInfoEntry>)

}

OfferPositionCriteriums.propTypes = {
    criteriums: PropTypes.array.isRequired
}

export default OfferPositionCriteriums;